<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageLeft>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">    
                <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/marketing/in-game-activations.jpg" alt=""></transition></div>                        
                  <div class="page-content content">
                    <transition name="slide-fade" mode="out-in" appear>
                      <TitleContent h2="Marketing" h1="In-Game Activations" />
                    </transition>
                    <transition name="slide-fade" mode="out-in" appear>
                      <div class="text-content">                                              
                        <FeatureListItem icon="marketing/icon_phone.svg" description="digital screen inventory"/>                                                              
                        <FeatureListItem icon="marketing/icon_radio.svg" description="radio broadcast liners"/>                       
                        <FeatureListItem icon="marketing/icon_lightning.svg" description="mobile ticket booth activation"/>                                             
                        <FeatureListItem icon="marketing/icon_music.svg" description="performers’ music playing inside bowl"/>                       
                        <p class="footnote">Access to Raiders and ASM Global partnership assets listed above are offered and determined on a show-by-show basis. </p>
                      </div>                    
                    </transition>
                  </div>                
            </div>
        </div>
    </template>
    </PageLeft>    
  </div>
</template>

<script>
import PageLeft from "@/patterns/PageLeft.vue";
import TitleContent from "@/patterns/TitleContent.vue";
import FeatureListItem from "@/patterns/FeatureListItem.vue";

export default {
  name: "InGameAcivations",
  components: { PageLeft, TitleContent, FeatureListItem },
  data: () => ({
    scrollContent: false,    
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>